/**
 * 移动端公共js
 * 每开一个新页面的时候@一下
 * @chenwei
 */
import React, { Component } from 'react';
import { InitLinkShare } from '@nativeApp/util';
import { defineNativeDefault } from '@nativeApp/defineNativeDefault';
import util from '../../page/util/index';
import './index.css';

const flexible = require('asset/js/flexible.debug.js');

const mobilePublicComponent = (WrappedComponent) => {
  return class extends Component {
    componentDidMount() {
      if (typeof window !== 'undefined') {
        flexible.flexible(window, window.lib || (window.lib = {}));
        util.initWeChat(); // TODO 移除，由 InitLinkShare 方法统一处理
        InitLinkShare();
      }
      try {
        defineNativeDefault();
      } catch (error) {
        console.error('初始化默认app方法出错', error);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default mobilePublicComponent;
